import React, { useContext, useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import loginimg from "../Assets/Img/loginsideimg.png";
import axiosMain from "../http/axiosMain";
import { GlobalContext } from "../../utils/GlobalContext";

function OtpVerification({ setIsLoggedIn }) {
  const { setisLogdin } = useContext(GlobalContext);
  const { id } = useParams(); // Get id from URL params
  const location = useLocation();
  const navigate = useNavigate();
  const inputRefs = useRef([]);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone_no, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [isLoginWithEmail, setIsLoginWithEmail] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const { setIsLogdin, setUserData } = useContext(GlobalContext); // Add setUserData

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  useEffect(() => {
    if (location.state?.loginWithEmail) {
      setIsLoginWithEmail(true);
      setEmail(location.state.email);
    } else {
      const storedPhone = localStorage.getItem("phone_no");
      console.log("Stored Phone Number:", storedPhone);
      setPhoneNo(storedPhone || "");
    }
  }, [location]);

  useEffect(() => {
    if (countdown > 0) {
      setIsResendDisabled(true);
      const timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setIsResendDisabled(false);
    }
  }, [countdown]);

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
    if (e.key === "Enter") {
      handleSubmitOtp();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pasteData)) {
      setOtp([...pasteData]);
      pasteData.split("").forEach((char, i) => {
        if (inputRefs.current[i]) {
          inputRefs.current[i].value = char;
        }
      });
      inputRefs.current[5].focus();
    }
  };

  const handleSubmitOtp = async () => {
    const otpString = otp.join("");
    if (otpString.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      let apiEndpoint = isLoginWithEmail
        ? "/api/auth/verifyEmailOtp"
        : "/api/auth/verifyPhoneOtp";
      let requestData = isLoginWithEmail
        ? { email, otp: otpString }
        : { phoneNo: phone_no, otp: otpString };

      const response = await axiosMain.post(apiEndpoint, requestData, {
        withCredentials: true,
      });
      const token = response.data.token;
      if (token) {
        localStorage.setItem("authToken", token);
        setisLogdin(true);
      }
      if (response.status === 200) {
        const meResponse = await axiosMain.get("/api/v1/me", {
          withCredentials: true,
        });
        if (meResponse.status === 200) {
          localStorage.setItem("user", JSON.stringify(meResponse.data));
          localStorage.setItem("user_id", meResponse.data.user?.user_id);
          const profileResponse = await axiosMain.get(
            "/api/v1/get-brand-profile"
          );
          if (profileResponse.status === 200 && profileResponse.data?.user) {
            setUserData(profileResponse.data.user); // Update GlobalContext
          }
          const role = meResponse.data?.user?.role;
          if (role) localStorage.setItem("userType", role);

          console.log("iiiiiii", meResponse.subscription_id);

          if (meResponse?.data?.user?.subscription_id === null) {
            const plan_id = "free";
            const subscribeResponse = await axiosMain.post(
              "/api/subscription/subscribe",
              {
                plan_id: plan_id,
              }
            );
          }

          role === "brand"
            ? navigate("/brand-home", { replace: true })
            : role === "influencer"
            ? navigate("/influencer-home", { replace: true })
            : role === "admin"
            ? navigate("/admin/influencers", { replace: true })
            : navigate("/", { replace: true });
        } else {
          setError(meResponse.data?.message || "Failed to fetch user data.");
        }
      } else {
        setError(response.data?.message || "Failed to verify OTP. Try again.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to verify OTP. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setCountdown(60); // Restart countdown

    const apiEndpoint = isLoginWithEmail
      ? "/api/auth/sendEmailOtp"
      : "/api/auth/sendPhoneOtp";
    const requestData = isLoginWithEmail ? { email } : { phoneNo: phone_no };

    try {
      const response = await axiosMain.post(apiEndpoint, requestData);

      if (response.status === 200) {
        console.log("OTP Resent Successfully");
      } else {
        console.log("Failed to resend OTP");
      }
    } catch (err) {
      console.log("Error resending OTP", err);
    }
  };

  return (
    <div className="container-mobileotp p-0 mt-5 mb-5">
      <div className="card">
        <div className="row no-gutters">
          <div className="col-xs-12 col-sm-12 col-md-12 left">
            <img src={loginimg} alt="Login visual" className="img" />
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 right">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                <h2>
                  Collaborate.
                  <br /> Create. Connect.
                </h2>
                <div className="otp-input-fields" onPaste={handlePaste}>
                  {otp.map((value, index) => (
                    <input
                      key={index}
                      type="tel"
                      className="otp__digit"
                      value={value}
                      maxLength={1}
                      autoFocus={index === 0}
                      onChange={(e) => handleOtpChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      ref={(el) => (inputRefs.current[index] = el)}
                      aria-label={`OTP digit ${index + 1}`}
                    />
                  ))}
                </div>

                <button
                  type="button"
                  className="btn btn-outline-success btn-lg mt-2"
                  onClick={handleResendOtp}
                  disabled={isResendDisabled}
                >
                  {countdown > 0 ? `Resend OTP (${countdown}s)` : "Resend OTP"}
                </button>

                {error && <p className="error-text text-danger">{error}</p>}
                <div className="d-flex flex-column gap-3">
                  <button
                    type="button"
                    className="btn btn-outline-success btn-lg mt-4"
                    onClick={handleSubmitOtp}
                    disabled={loading || otp.join("").length !== 6}
                  >
                    {loading ? "Verifying OTP..." : "Verify OTP"}
                  </button>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 footer">
                <div className="signup-instruction">
                  By continuing, you agree to our terms and conditions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtpVerification;
